import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { hasDemand } from "lib/authorization/has-demand"
import { authoringRoute } from "authoring/routes/authoring.runtime"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { AuthoringUsers } from "authoring/users/components/authoring-users"
import { AUTHORING_MANAGE_GLOBAL_USERS_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

registerConditionalPageNavigation(
    () => hasDemand(AUTHORING_MANAGE_GLOBAL_USERS_DEMAND) && hasDemand("!sharing"),
    "/authoring/users",
    "Users",
    "gridicons:multiple-users",
    {
        group: "Admin",
        priority: 580,
    }
)

authoringRoute.register(
    "users",
    <DemandGuard demands={[AUTHORING_MANAGE_GLOBAL_USERS_DEMAND]}>
        <AuthoringUsers $lazy />
    </DemandGuard>
)
